import BookIndex from "components/shared/book/list";
import SharedReactTable from "components/shared/reactTable";
import { moduleTypes } from "helpers/enums";
import { paths } from "helpers/paths";
import {
    BooleanColumnFilter,
    DebouncedRangeColumnFilter,
    rowIndexColumn,
    SelectColumnFilter,
} from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import { enumLabel } from "helpers/system";
import React from "react";
import { Link } from "react-router-dom";
import { getOrganizationNames } from "sources/admin";

export class PopupTemplates extends BookIndex {
    get tableColumns() {
        return [
            rowIndexColumn,
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            {
                Header: "Название",
                accessor: "header",
                filterable: true,
                Cell: ({ value, row: { original } }) => {
                    const { id } = original;
                    return <Link to={paths.popupTemplatesShow(id)}>{value}</Link>;
                },
            },
            {
                Header: "Модуль",
                accessor: "moduleType",
                filterable: true,
                filterType: "enum",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{ options: moduleTypes, inputProps: { name: "moduleType" } }}
                    />
                ),
                Cell: ({ value }) => (value ? enumLabel(moduleTypes, value) : ""),
            },
            {
                Header: "Организации",
                accessor: "organizations",
                id: "organizationIds",
                sortable: false,
                filterable: true,
                filterType: "arrayContainsWithEmpty",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: getOrganizationNames,
                            inputProps: { name: "organizationIds" },
                            propName: "name",
                        }}
                    />
                ),
                Cell: ({ value }) => (value?.length ? value.join(", ") : "Всем организациям"),
            },
            {
                Header: "Без возможности закрытия",
                accessor: "noWayToClose",
                sortable: false,
                width: 150,
                Cell: ({ value }) => <div className="text-center">{value ? "Да" : "Нет"}</div>,
                CSVExport: ({ value }) => (value ? "Да" : "Нет"),
            },
            {
                Header: "Для белого списка организаций",
                accessor: "forWhiteListOrganizations",
                sortable: false,
                filterable: true,
                filterType: "boolean",
                Filter: (props) => {
                    const defaultValue = { id: "forWhiteListOrganizations", value: "all", filterType: "boolean" };
                    const options = [
                        { label: "Показать все", value: "all" },
                        { label: "Удаленные", value: "true" },
                        { label: "Не удаленные", value: "false" },
                    ];
                    return <BooleanColumnFilter {...props} options={options} defaultValue={defaultValue} />;
                },
                Cell: ({ value }) => <div className="text-center">{value ? "Да" : "Нет"}</div>,
                CSVExport: ({ value }) => (value ? "Да" : "Нет"),
            },
            {
                Header: "Кол-во дней просрочки",
                accessor: "countOfExpiredDays",
                filterable: true,
                filterType: "numberRange",
                Filter: DebouncedRangeColumnFilter,
            },
            {
                Header: "Кол-во дней до конца просрочки",
                accessor: "daysBeforeSubscriptionExpires",
                filterable: true,
                filterType: "numberRange",
                Filter: DebouncedRangeColumnFilter,
            },
            {
                Header: "Кол-во дней после окончания подписки, через которое будет заблокирован кабинет",
                accessor: "daysUntilBlocking",
                filterable: true,
                filterType: "numberRange",
                Filter: DebouncedRangeColumnFilter,
            },
        ];
    }

    renderHead = () => {
        return (
            <div className="book-list__head-wrap">
                <div className="book-list__head">
                    <div className="book-list__head-close close close--sm" onClick={this.close} />
                    <div className="book-list__head-title">
                        {this.props.title}
                        {this.renderCounter()}
                    </div>
                    <div className="btn-toolbar">{this.renderCreateButton()}</div>
                </div>
            </div>
        );
    };

    renderListComponent = () => <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
}

export default tableContainer(PopupTemplates, "popup-templates");
